import type { Root } from "./prototypeTypes";

const BOOTSTRAPPED_KEY = "__deepmoxBootstrapped";

/**
 * True once bootstrapApp has injected the SPA shell (Mode B) or bound the SSR
 * shell (Mode A) and mounted the controller.
 *
 * Vite dynamic chunks import the entry bundle at its bare URL. If the HTML
 * <script> tag ever loads it under a different URL (e.g. a cache-busting ?v=
 * query), the browser instantiates the whole entry module graph twice and
 * re-runs bootstrapApp() — injecting a duplicate shell that duplicates every
 * view and mount, and double-binds every listener. The first instance owns the
 * DOM; this guard makes any later instantiation a no-op.
 */
export function isAppBootstrapped(root: Root): boolean {
	return (root as unknown as Record<string, unknown>)[BOOTSTRAPPED_KEY] === true;
}

export function markAppBootstrapped(root: Root): void {
	(root as unknown as Record<string, unknown>)[BOOTSTRAPPED_KEY] = true;
}
